var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M23.264 18.329c.673 1.187-.172 2.671-1.516 2.671H4.252c-1.347 0-2.187-1.486-1.516-2.671L11.484 2.89a1.736 1.736 0 013.032 0l8.748 15.439zM13 15.137c-.926 0-1.677.764-1.677 1.707 0 .943.75 1.707 1.677 1.707.926 0 1.677-.764 1.677-1.707 0-.943-.75-1.707-1.677-1.707zM11.408 9l.27 5.047a.44.44 0 00.437.42h1.77a.44.44 0 00.437-.42L14.592 9a.442.442 0 00-.437-.47h-2.31a.443.443 0 00-.437.47z"
  }))));
}

export default SvgExclamation;